import { Box } from '@mui/material';
import * as T from '../../components/Typography';
import colors from '../../theme/colors';
import * as S from './style';
import FAQSection from '../../components/FAQ';
import { useAuth } from '../../context/auth';
import { useGetUserSurvey } from '../../api-calls/survey.queries';

const FAQ = () => {
  const { user } = useAuth();

  const { data } = useGetUserSurvey({
    salesforceContactId: user?.salesforceContactId
  });
  return (
    <S.Wrapper>
      <Box mt={6} width={'100%'}>
        <T.H4 mb={6} color={colors.neutral.shades.shade700}>
          FREQUENTLY ASKED QUESTIONS
        </T.H4>
        <FAQSection surveyEndDate={data?.endDate} />
      </Box>
    </S.Wrapper>
  );
};

export default FAQ;
